import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { ContestCharCount } from "@/types/contest-submission";

const ERROR_CODE_LABEL: Record<string, string> = {
  parse_timeout: "파싱 시간 초과",
  parse_error: "파싱 실패",
  invalid_hwp: "HWP 파일 손상",
  pdf_encrypted: "암호화된 PDF",
  no_text: "추출 가능한 텍스트 없음 (스캔본 등)",
  no_manuscript: "원고 없음",
};

/**
 * 서버 계산 글자수 표시. null(백필 전)은 "—", 상태별 라벨은 아래와 같다.
 * DONE 이 아닌 상태는 재계산(드로어의 재계산 버튼)으로 복구를 시도할 수 있다.
 */
export function ContestCharCountCell({
  charCount,
}: {
  charCount: ContestCharCount | null;
}) {
  if (!charCount) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }

  switch (charCount.status) {
    case "DONE":
      return (
        <span className="text-sm tabular-nums">
          {(charCount.value ?? 0).toLocaleString("ko-KR")}자
        </span>
      );
    case "PENDING":
      return <span className="text-xs text-muted-foreground">집계중…</span>;
    case "UNSUPPORTED":
    case "FAILED": {
      const label = charCount.status === "FAILED" ? "실패" : "추출불가";
      const reason = charCount.errorCode
        ? (ERROR_CODE_LABEL[charCount.errorCode] ?? charCount.errorCode)
        : null;
      return (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="text-xs text-amber-700 underline decoration-dotted underline-offset-2 cursor-help">
                {label}
              </span>
            </TooltipTrigger>
            {reason && <TooltipContent>{reason}</TooltipContent>}
          </Tooltip>
        </TooltipProvider>
      );
    }
    default:
      return <span className="text-xs text-muted-foreground">—</span>;
  }
}
